type AdminOfferEditable = {
  status?: string;
  responseStatus?: string;
  metadata?: {
    responseStatus?: 'pending' | 'accepted' | 'partially_accepted' | 'rejected';
    purchaseOrderId?: string;
  };
  linkedPurchaseOrder?: { _id?: string } | null;
};

export function canEditAdminOffer(offer: AdminOfferEditable | null | undefined): boolean {
  if (!offer) return false;
  const meta = offer.metadata || {};
  const response = String(offer.responseStatus || meta.responseStatus || '').toLowerCase();
  if (
    response === 'accepted' ||
    response === 'partially_accepted' ||
    offer.status === 'finalized'
  ) {
    return false;
  }
  if (meta.purchaseOrderId || offer.linkedPurchaseOrder?._id) return false;
  return true;
}
